import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { actions as toCollegeToolActions } from "../../../redux/modules/tocollagetool";
import { get } from "../../../utils/request";
import { jumpUrl } from "../../../utils/tool.js";
import "./style.css";
import "../../../index.css";
class ToCollegeToolResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      css: {},
    };
  }
  componentDidMount() {
    this.fixCss();
    this.requestUserCondition();
    this.requestIsBuy();
  }
  render() {
    const {
      userInfo,
      totalScore,
      wholeSubject,
      subjectCondition,
      majorCondition,
    } = this.props;
    return (
      <div>
        <div
          className={
            this.state.css.width > 750
              ? "to_college_tool_result_top"
              : "to_college_tool_result_top display_none"
          }
        >
          下载导出见底部区域
        </div>
        <div>
          <img
            className="to_college_tool_result_condition_img0"
            alt=""
            src={require("../../../images/tocollege/bg-2.png")}
          ></img>
          <div className="to_college_tool_result_condition">
            <img
              className="to_college_tool_result_condition_img1 major_top_12"
              alt=""
              src={require("../../../images/tocollege/subject.png")}
            ></img>
            <div className="major_top_10">
              {wholeSubject[subjectCondition[0]]}{" "}
              {wholeSubject[subjectCondition[1]]}{" "}
              {wholeSubject[subjectCondition[2]]}
            </div>
            <img
              className="to_college_tool_result_condition_img1 major_top_12"
              alt=""
              src={require("../../../images/tocollege/total.png")}
            ></img>
            <div className="major_top_10">{totalScore}</div>
            <img
              className="to_college_tool_result_condition_img2 major_top_12"
              alt=""
              src={require("../../../images/tocollege/major.png")}
            ></img>
            <div className="major_top_10 padding_left_20 padding_right_20">
              {majorCondition.map((item, index) => {
                return <span key={index}>{item}&nbsp;&nbsp;</span>;
              })}
            </div>
          </div>
        </div>
        {this.state.css.width > 750 ? (
          <div className="to_college_tool_result_content">
            候选志愿已产生，在参考前请务必阅读&nbsp;
            <NavLink className="color_008efe" to="/articledetail/6yBCb">
              必读 | 手把手教你，填报好80个志愿
            </NavLink>{" "}
            并充分理解清楚后，
            <a
              onClick={() => this.export()}
              className="color_008efe cursor_pointer"
            >
              下载导出
            </a>
            （如果不能下载导出或无反应，请
            <a
              style={{ textDecoration: "none" }}
              className="color_008efe cursor_pointer"
              target="_blank"
              href="https://www.google.cn/chrome/"
            >
              下载谷歌浏览器。
            </a>
            ）
          </div>
        ) : (
          <div className="to_college_tool_result_content">
            候选志愿已产生，在参考前请务必阅读&nbsp;
            <NavLink className="color_008efe" to="/articledetail/6yBCb">
              必读 | 手把手教你，填报好80个志愿
            </NavLink>{" "}
            并充分理解清楚后， 请使用正在登录的手机号{userInfo.phone}
            以及对应的密码（如果忘记密码，右下角-我的可以重新设置密码），
            登录浙考之家电脑网页版（zhekaozhijia.com）下载导出。
          </div>
        )}
      </div>
    );
  }

  /**
   * 获取用户是否购买的标识
   */
  requestIsBuy = () => {
    get("/public/v1/user/isBuy").then((res) => {
      if (res.data === false) {
        jumpUrl("pay");
      }
    });
  };

  export = () => {
    let fileName = "";
    fetch("/public/v1/toCollage/excel/export", {
      method: "get",
      responseType: "blob",
    })
      .then((res) => {
        fileName = res.headers
          .get("Content-Disposition")
          .split(";")[1]
          .split("=")[1];
        return res.blob();
      })
      .then((blob) => {
        new Blob([blob], {
          type: "application/vnd.ms-excel",
        });
        fileName = fileName.replace(".xls", "") + "候选志愿" + ".xls";
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      });
  };
  fixCss = () => {
    let width = window.innerWidth;
    this.setState({
      css: {
        width: width,
      },
    });
  };
  /**
   * 请求用户条件
   */
  requestUserCondition = () => {
    const { dispatch } = this.props;
    get("/public/v1/toCollage/condition").then((res) => {
      let majorCondition = JSON.parse(JSON.stringify(res.data.majorCondition));
      let scoreCondition = JSON.parse(JSON.stringify(res.data.scoreCondition));
      let subjectCondition = JSON.parse(
        JSON.stringify(res.data.subjectCondition)
      );
      let totalScore = JSON.parse(JSON.stringify(res.data.totalScore));
      let subjectScore = this.props.subjectScore;
      for (let i = 0; i < scoreCondition.length; i++) {
        subjectScore[scoreCondition[i].subject] = scoreCondition[i].score;
      }
      let preSubjectScore = JSON.parse(JSON.stringify(subjectScore));
      dispatch(toCollegeToolActions.setScoreCondition(scoreCondition));
      dispatch(toCollegeToolActions.setPreSubjectScore(preSubjectScore));
      dispatch(toCollegeToolActions.setSubjectCondition(subjectCondition));
      dispatch(toCollegeToolActions.setTotalScore(totalScore));
      dispatch(toCollegeToolActions.setMajorCondition(majorCondition));
    });
  };
}
const mapStateToProps = (state) => {
  return {
    userInfo: state.user.userData.userInfo,
    subjectCondition: state.toCollageTool.toCollageData.subjectCondition,
    wholeSubject: state.toCollageTool.toCollageData.wholeSubject,
    totalScore: state.toCollageTool.toCollageData.totalScore,
    majorCondition: state.toCollageTool.toCollageData.majorCondition,
    subjectScore: state.toCollageTool.toCollageData.subjectScore,
  };
};
export default connect(mapStateToProps)(ToCollegeToolResult);



// WEBPACK FOOTER //
// ./src/containers/ToCollegeTool/ToCollegeToolResult/index.js